import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledIconButton,
  StyledToggleButton,
  StyledViewSelector,
} from './styles';
import { KizenTypography } from '__app/typography';
import { colorsButton, grayScale } from '__app/colors';
import Icon from '__components/Kizen/Icon';

export type ViewVariant = 'live' | 'dry';

type ViewSelectorProps = {
  view: ViewVariant;
  onChange: (value: ViewVariant) => void;
};

export const ViewSelector = ({ view, onChange }: ViewSelectorProps) => {
  const { t } = useTranslation();

  const onChangeView = ({ value }: { value: ViewVariant }) => {
    onChange(value);
  };

  const options = useMemo(
    () => [
      {
        value: 'live',
        label: (
          <StyledIconButton
            as="span"
            title={t('Live Runs')}
            color={view === 'live' ? grayScale.white : colorsButton.blue}
          >
            <Icon icon="globe" />
          </StyledIconButton>
        ),
      },
      {
        value: 'dry',
        label: (
          <StyledIconButton
            as="span"
            title={t('Dry Runs')}
            color={view === 'dry' ? grayScale.white : colorsButton.blue}
          >
            <Icon icon="flask" />
          </StyledIconButton>
        ),
      },
    ],
    [t, view]
  );

  return (
    <StyledViewSelector>
      {<KizenTypography>{t('View')}</KizenTypography>}
      <StyledToggleButton
        options={options}
        value={view}
        onChange={onChangeView}
      />
    </StyledViewSelector>
  );
};
